// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  border: 1px solid lightgrey;
  box-shadow: rgba(27, 31, 35, 0.04) 0 1px 0, rgba(255, 255, 255, 0.25) 0 1px 0 inset;
  overflow: hidden;
  background-color: #d9d9d9;
  padding-bottom: 1rem;
}

.map {
  width: 90%;
  height: 30vh;
  margin-top: 1rem;
}

.info-section {
  scroll-margin-top: 2rem;
}

.service-info-text {
  padding: 1rem;
  text-align: center;
  font-family: "WMFD-Bold";
}

.services-banner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  gap: 4rem;
  height: 30vh;
  width: 100%;
}

.services-banner-text {
  color: white;
  font-family: "WMFD-Bold";
  text-align: center;
  font-size: 6rem;
  margin-top: 2rem;
}

.services-banner-subtext {
  color: white;
  font-family: "WMFD-SemiBold";
  text-align: center;
  font-size: 3rem;
}
@media (max-width: 1200px) {
  .services-banner {
    height: 25vh;
    gap: 1rem;
  }
  .services-banner-text {
    font-size: 3rem;
  }
  .services-banner-subtext {
    font-size: 1.5rem;
  }
}

@media (max-width: 425px) {
  .services-banner {
    height: 20vh;
    gap: 0rem;
  }
  .services-banner-text {
    font-size: 2rem;
  }
  .services-banner-subtext {
    font-size: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Services.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,mFAAmF;EACnF,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,YAAY;IACZ,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 15px;\r\n  border: 1px solid lightgrey;\r\n  box-shadow: rgba(27, 31, 35, 0.04) 0 1px 0, rgba(255, 255, 255, 0.25) 0 1px 0 inset;\r\n  overflow: hidden;\r\n  background-color: #d9d9d9;\r\n  padding-bottom: 1rem;\r\n}\r\n\r\n.map {\r\n  width: 90%;\r\n  height: 30vh;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.info-section {\r\n  scroll-margin-top: 2rem;\r\n}\r\n\r\n.service-info-text {\r\n  padding: 1rem;\r\n  text-align: center;\r\n  font-family: \"WMFD-Bold\";\r\n}\r\n\r\n.services-banner {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-size: cover;\r\n  gap: 4rem;\r\n  height: 30vh;\r\n  width: 100%;\r\n}\r\n\r\n.services-banner-text {\r\n  color: white;\r\n  font-family: \"WMFD-Bold\";\r\n  text-align: center;\r\n  font-size: 6rem;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.services-banner-subtext {\r\n  color: white;\r\n  font-family: \"WMFD-SemiBold\";\r\n  text-align: center;\r\n  font-size: 3rem;\r\n}\r\n@media (max-width: 1200px) {\r\n  .services-banner {\r\n    height: 25vh;\r\n    gap: 1rem;\r\n  }\r\n  .services-banner-text {\r\n    font-size: 3rem;\r\n  }\r\n  .services-banner-subtext {\r\n    font-size: 1.5rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 425px) {\r\n  .services-banner {\r\n    height: 20vh;\r\n    gap: 0rem;\r\n  }\r\n  .services-banner-text {\r\n    font-size: 2rem;\r\n  }\r\n  .services-banner-subtext {\r\n    font-size: 0.75rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
